import React, { Component } from "react";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";

export default class SortDropdownTrainerLocation extends Component {

    constructor(props) {
        super(props);

        var location = this.props.locationLabel;
        if(location == "") location = "Select a Location"

        this.state = {
            location: location
        }
    }

    handleSelect = (gym_id) => {
        var location;
        var abbrev;
        console.log("drop down location gym_id: " + gym_id);
        if(gym_id === "4b07edc0-ebf0-11e9-85dd-9b2fcf560e30") {
            location = "P4L Training - Castro"
            abbrev   = "castro";
        } else if(gym_id === "c84934b0-ebf0-11e9-911a-fbdac363f28e") {
            location = "P4L Training - FiDi"
            abbrev   = "fidi";
        } else {
            location = "P4L Training - Hayes Valley"
            abbrev   = "hayes";
        }

        this.setState ({
            location: location
        }, function() {
            this.props.locationResults(gym_id, abbrev);
        })
    }

    render() {

        return (
            <div>
                <ButtonToolbar className = "btnToolbarSortMultipleEx pull-right">
                    <DropdownButton
                          bsStyle="default"
                          title  = {this.state.location}
                          noCaret
                          id="dropdown-no-caret"
                          className = "btnToolbarSortMultipleExc"
                          style     = {{width: 250, textAlign: "left", borderRadius: 0, border: "2px solid #ccc"}}
                          onSelect  = {this.handleSelect}
                    >
                        <MenuItem eventKey  = "4b07edc0-ebf0-11e9-85dd-9b2fcf560e30"
                                  className = "menuItemToolbarAddMultipleExc"
                                  style     = {{display: "inline-block", width: 230}} >
                            P4L Training - Castro
                        </MenuItem>
                        <MenuItem eventKey  = "c84934b0-ebf0-11e9-911a-fbdac363f28e"
                                  className = "menuItemToolbarAddMultipleExc"
                                  style     = {{display: "inline-block", width: 230}} >
                            P4L Training - FiDi
                        </MenuItem>
                        <MenuItem eventKey  = "001877c0-ebf1-11e9-a945-d5dded95ac71"
                                  className  ="menuItemToolbarAddMultipleExc"
                                  style     = {{display: "inline-block", width: 230, height: 30}} >
                            P4L Training - Hayes Valley
                        </MenuItem>
                    </DropdownButton>
                </ButtonToolbar>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/SortDropdownTrainerLocation.js